// @flow
import firestore from '../services/firestore';
import carSchema from '../../server/shared/schemas/car';

export default carSchema(firestore);